import React, { useEffect } from 'react';
import { ArrowLeft, ShieldCheck, ChevronUp } from 'lucide-react';

// --- CUSTOM SOCIAL ICONS ---
const FacebookIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>);
const TwitterIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z"></path></svg>);
const InstagramIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line></svg>);
const YoutubeIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33 2.78 2.78 0 0 0 1.94 2C5.12 19.5 12 19.5 12 19.5s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.33 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon></svg>);
const LinkedinIcon = () => (<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle></svg>);

export default function TermsOfUse() {
  
  // Auto-scroll to top when page loads
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0b1121', color: '#f8fafc', fontFamily: 'system-ui, -apple-system, sans-serif', overflowX: 'hidden' }}>
      
      <style>{`
        ::-webkit-scrollbar { width: 8px; }
        ::-webkit-scrollbar-track { background: #0b1121; }
        ::-webkit-scrollbar-thumb { background: #1e293b; border-radius: 4px; }
        ::-webkit-scrollbar-thumb:hover { background: #334155; }
        
        .legal-content h3 {
          color: #d89b16; /* HUNCH Gold */
          font-size: 22px;
          margin-top: 40px;
          margin-bottom: 16px;
          border-bottom: 1px solid #1e293b;
          padding-bottom: 8px;
        }
        .legal-content p {
          color: #94a3b8;
          line-height: 1.8;
          font-size: 16px;
          margin-bottom: 20px;
        }
        
        .f-link {
          color: #fef3c7;
          text-decoration: none;
          font-size: 14px;
          display: block;
          margin-bottom: 12px;
          transition: color 0.2s;
        }
        .f-link:hover {
          color: #ffffff;
        }
        .social-icon {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 36px;
          height: 36px;
          border-radius: 50%;
          border: 1px solid #475569;
          color: #94a3b8;
          transition: all 0.2s;
        }
        .social-icon:hover {
          border-color: #f8fafc;
          color: #f8fafc;
          background: rgba(255,255,255,0.1);
        }
      `}</style>

      {/* --- NAVBAR --- */}
      <nav style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 40px', background: 'rgba(11, 17, 33, 0.9)', backdropFilter: 'blur(10px)', position: 'fixed', width: '100%', top: 0, zIndex: 100, boxSizing: 'border-box', borderBottom: '1px solid #1e293b' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img src={`${process.env.PUBLIC_URL}/hunch_1.png`} alt="HUNCH Logo" style={{ height: '52px' }} />
        </div>
        <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
          <a href="/" style={{ background: '#121b2f', color: '#f8fafc', border: '1px solid #1e293b', padding: '10px 24px', borderRadius: '8px', fontSize: '13px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', textDecoration: 'none', transition: 'all 0.2s' }}
             onMouseOver={(e) => e.currentTarget.style.borderColor = '#d89b16'}
             onMouseOut={(e) => e.currentTarget.style.borderColor = '#1e293b'}>
            <ArrowLeft size={16} /> Back to Home
          </a>
        </div>
      </nav>

      {/* --- CONTENT SECTION --- */}
      <section style={{ paddingTop: '160px', paddingBottom: '80px', paddingInline: '20px', position: 'relative' }}>
        <div style={{ position: 'absolute', top: '0', left: '50%', transform: 'translateX(-50%)', width: '800px', height: '600px', background: 'radial-gradient(circle, rgba(14,165,233,0.08) 0%, rgba(11,17,33,0) 70%)', zIndex: 0, pointerEvents: 'none' }}></div>
        
        <div style={{ position: 'relative', zIndex: 1, maxWidth: '900px', margin: '0 auto' }}>
          
          <div style={{ textAlign: 'center', marginBottom: '60px' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', background: 'rgba(14, 165, 233, 0.1)', border: '1px solid rgba(14, 165, 233, 0.2)', color: '#0ea5e9', padding: '8px 16px', borderRadius: '20px', fontSize: '12px', fontWeight: '700', letterSpacing: '1px', marginBottom: '24px' }}>
              <ShieldCheck size={14} /> LEGAL & COMPLIANCE
            </div>
            <h1 style={{ fontSize: '48px', fontWeight: '800', margin: '0 0 16px', color: '#f8fafc' }}>Terms of Use</h1>
            <p style={{ fontSize: '16px', color: '#94a3b8' }}>Last Updated: April 2026</p>
          </div>

          <div className="legal-content" style={{ background: '#121b2f', padding: '50px 60px', borderRadius: '16px', border: '1px solid #1e293b', boxShadow: '0 25px 50px -12px rgba(0,0,0,0.5)' }}>
            
            <p>Welcome to HUNCH Automation (Pvt.) Ltd. These Terms of Use govern your access to and use of our website, the MRS9000 Telemetry Engine, and all associated industrial software products and services. By downloading, installing, or utilizing our software, you agree to be bound by these terms.</p>

            <h3>1. Software License & Usage</h3>
            <p>The MRS9000 Telemetry Engine operates on a hardware-bound, offline security model. Upon purchasing a license, HUNCH Automation grants you a non-exclusive, non-transferable, and revocable right to install and operate the software on a single, designated industrial workstation. The software is cryptographically locked to the hardware's Machine ID. Any attempt to bypass, clone, or virtualize this security mechanism will result in immediate and permanent license revocation.</p>

            <h3>2. Air-Gapped Environment Obligations</h3>
            <p>Our software is designed specifically for highly secure, air-gapped intranet environments. We guarantee that the MRS9000 does not contain hidden telemetry trackers, "phone home" mechanisms, or cloud dependencies. Consequently, you are solely responsible for backing up your local SQLite database files. HUNCH Automation holds no liability for data loss resulting from local hardware failure or user error.</p>

            <h3>3. Limitation of Liability</h3>
            <p>In no event shall HUNCH Automation (Pvt.) Ltd., its directors, or its engineering team be held liable for any indirect, incidental, or consequential damages arising from the use or inability to use our software. This includes, but is not limited to, factory downtime, hardware communication failures, or misconfigured Modbus parameters leading to incorrect analytical data.</p>

            <h3>4. Intellectual Property</h3>
            <p>All software architecture, visual dashboards, source code, and documentation (including the offline setup guide) remain the exclusive intellectual property of HUNCH Automation. You may not reverse-engineer, decompile, or re-brand our user interfaces for commercial resale without explicit written consent.</p>

            <h3>5. Contact & Support</h3>
            <p>If you require technical assistance, license transfers due to hardware upgrades, or custom API integrations, please contact our engineering support team directly at <strong>support@hunchcloud.com</strong>.</p>

          </div>

        </div>
      </section>

      {/* --- RE-ENGINEERED CORPORATE FOOTER --- */}
      <footer style={{ background: '#000000', color: '#f8fafc', padding: '0' }}>
        <div style={{ background: 'linear-gradient(to bottom, #d89b16, #000)', padding: '60px 40px' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '40px' }}>
            
            <div>
              <img src={`${process.env.PUBLIC_URL}/hunch_white.png`} alt="HUNCH Logo" style={{ height: '48px', marginBottom: '20px', display: 'block' }} />
              <p style={{ color: '#fef3c7', fontSize: '13px', lineHeight: '1.6', margin: 0 }}>
                Building simple and powerful monitoring dashboards tailored to enterprise needs.
              </p>
            </div>

            <div>
              <h4 style={{ color: '#fff', fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 20px 0' }}>Useful Links</h4>
              <a href="/" className="f-link">Home</a>
              <a href="/#overview" className="f-link">Our Offer</a>
              <a href="#" className="f-link">About Us</a>
              <a href="#" className="f-link">Contact Us</a>
            </div>

            <div>
              <h4 style={{ color: '#fff', fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 20px 0' }}>Terms & Conditions</h4>
              <a href="/terms-of-use" className="f-link">Terms of use</a>
              <a href="#" className="f-link">Privacy Policy</a>
            </div>

            <div>
              <h4 style={{ color: '#fff', fontSize: '14px', fontWeight: '700', textTransform: 'uppercase', letterSpacing: '1px', margin: '0 0 20px 0' }}>Get To Know Us</h4>
     
              <a href="#" className="f-link">Contact Us</a>
            </div>

          </div>
        </div>

        <div style={{ background: '#000', padding: '20px 40px', position: 'relative', borderTop: '1px solid #d89b16' }}>
          <div style={{ maxWidth: '1200px', margin: '0 auto', display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', alignItems: 'center', gap: '20px' }}>
            <div style={{ fontSize: '13px', color: '#94a3b8' }}>
              Copyright &copy; 2006 - 2026 <strong>HUNCH Automation (Pvt.) Ltd.</strong> | All Rights Reserved
            </div>
            
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <span style={{ fontSize: '13px', color: '#f8fafc', fontWeight: '600' }}>Follow Us:</span>
              <a href="https://www.facebook.com/cloud.hunch" target="_blank" rel="noopener noreferrer" className="social-icon"><FacebookIcon /></a>
              <a href="https://x.com/HunchCloud" target="_blank" rel="noopener noreferrer" className="social-icon"><TwitterIcon /></a>
              <a href="https://www.instagram.com/hunchcloud/" target="_blank" rel="noopener noreferrer" className="social-icon"><InstagramIcon /></a>
              <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer" className="social-icon"><YoutubeIcon /></a>
              <a href="https://www.linkedin.com/company/hunch-cloud/" target="_blank" rel="noopener noreferrer" className="social-icon"><LinkedinIcon /></a>
            </div>
          </div>

          <button 
            onClick={scrollToTop}
            style={{ position: 'absolute', right: '40px', top: '-24px', width: '48px', height: '48px', borderRadius: '50%', background: '#d89b16', color: '#000', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', boxShadow: '0 4px 12px rgba(0,0,0,0.5)', transition: 'transform 0.2s' }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-4px)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
            aria-label="Back to top"
          >
            <ChevronUp size={24} />
          </button>
        </div>
      </footer>

    </div>
  );
}